import { ArrayV2 } from "../../util/ArrayV2";
import { DataDRequest } from "../DRequest";
import { Entidad } from "../Entidad";
import { Global } from "../Global";
import { ICatalogoSATClaveProductServ, ICatalogoSATClaveUnidad } from "../entidad/Factura";
import { DataUtil } from "../util/Util";
import { _SvFacturaObtenerCatalogoSATClaveProductServ, _SvFacturaObtenerCatalogoSATClaveUnidad } from "./FacturaCatalogoSAT";

type TFinanzaCargo = Entidad.IFinanzaCargo;
type IEscuela = Entidad.IEscuela;
interface IExtraData {
    IdUsuario: number;
    IdOrganizacion?: number;
}

export const _DICC_FINANZAS_CARGOS: Map<number, TFinanzaCargo> = new Map();

const REQUESTID = Entidad.CTipoRequest.FinanzaCargo;

export function _SvFinanzasObtenerListaCargos(escuelas: IEscuela[]): Promise<DataDRequest.IRequestResponseListA<TFinanzaCargo>[]> {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "finanzas/ObtenerListaCargos"
    return new ArrayV2<IEscuela>()
        ._Push(...escuelas)
        ._MapAwait(async ({ IdKinder }) => {
            const currentDateStr = await DataUtil._GetMaxDate(REQUESTID, IdKinder);
            const params = {
                "IdOrganizacion": DataUtil._Usuario.IdOrganizacion,
                "IdEscuela": IdKinder,
                "Modificacion": currentDateStr
            }
            return DataDRequest._Request4List(url, "GET", params, REQUESTID, IdKinder);
        })
}

export async function _SvFinanzasNuevoCargo(objCargo: TFinanzaCargo) {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "finanzas/NuevoCargoV3";
    objCargo.TipoInteres = _SvFinanzasUtilEvaluarTipoInteres(objCargo)
    objCargo.IntervaloBloque = _SvFinanzasUtilEvaluarIntervaloBloque(objCargo)
    objCargo.TipoTasa = _SvFinanzasUtilEvaluarTipoTasa(objCargo)
    const params = <Partial<TFinanzaCargo> & IExtraData>{
        "IdOrganizacion": DataUtil._Usuario.IdOrganizacion,
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "Nombre": objCargo.Nombre,
        "TipoValor": objCargo.TipoValor,
        "Valor": objCargo.Valor,
        "Periodicidad": objCargo.Periodicidad,
        "MesAplicacion": objCargo.MesAplicacion,
        "DiaAplicacion": objCargo.DiaAplicacion,
        "DiaMorosidad": objCargo.DiaMorosidad,
        "DiaVencimiento": objCargo.DiaVencimiento,
        "TipoRecargo": objCargo.TipoRecargo,
        "TipoInteres": objCargo.TipoInteres,
        "ValorRecargo": objCargo.ValorRecargo,
        "IdEscuela": objCargo.IdEscuela,
        "TipoTasa": objCargo.TipoTasa,
        "IntervaloBloque": objCargo.IntervaloBloque,
        "ClaveProdServSAT": objCargo.ClaveProdServSAT,
        "NombreProdServSAT": objCargo.NombreProdServSAT,
        "ClaveUnidadSAT": objCargo.ClaveUnidadSAT,
        "NombreUnidadSAT": objCargo.NombreUnidadSAT,
        "IdAgrupador": objCargo.IdAgrupador,
    }

    const res = await DataDRequest._Request5<TFinanzaCargo>(url, "POST", params);
    res.Datos = objCargo;
    return res;
}

export async function _SvFinanzasNuevoCargoDescuento(datos: TFinanzaCargo) {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "finanzas/NuevoCargoDescuento";
    const params = <Partial<TFinanzaCargo> & IExtraData>{
        IdOrganizacion: DataUtil._Usuario.IdOrganizacion,
        IdUsuario: DataUtil._Usuario.IdUsuario,
        Nombre: datos.Nombre,
        TipoValor: datos.TipoValor,
        Valor: datos.Valor,
        IdEscuela: datos.IdEscuela
    }

    const res = await DataDRequest._Request5<TFinanzaCargo>(url, "POST", params);
    res.Datos = datos;
    return res;
}

export async function _SvFinanzasActualizarCargo(objCargo: TFinanzaCargo) {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "finanzas/ActualizarCargoV3";
    objCargo.TipoInteres = _SvFinanzasUtilEvaluarTipoInteres(objCargo)
    objCargo.IntervaloBloque = _SvFinanzasUtilEvaluarIntervaloBloque(objCargo)
    objCargo.TipoTasa = _SvFinanzasUtilEvaluarTipoTasa(objCargo)
    const params = <Partial<TFinanzaCargo> & IExtraData>{
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "IdCargo": objCargo.ID,
        "Nombre": objCargo.Nombre,
        "Valor": objCargo.Valor,
        "Periodicidad": objCargo.Periodicidad,
        "MesAplicacion": objCargo.MesAplicacion,
        "DiaAplicacion": objCargo.DiaAplicacion,
        "DiaMorosidad": objCargo.DiaMorosidad,
        "DiaVencimiento": objCargo.DiaVencimiento,
        "TipoRecargo": objCargo.TipoRecargo,
        "TipoInteres": objCargo.TipoInteres,
        "ValorRecargo": objCargo.ValorRecargo,
        "TipoTasa": objCargo.TipoTasa,
        "IntervaloBloque": objCargo.IntervaloBloque,
        "ClaveProdServSAT": objCargo.ClaveProdServSAT,
        "NombreProdServSAT": objCargo.NombreProdServSAT,
        "ClaveUnidadSAT": objCargo.ClaveUnidadSAT,
        "NombreUnidadSAT": objCargo.NombreUnidadSAT,
        "IdAgrupador": objCargo.IdAgrupador,
    }
    return DataDRequest._Request5(url, "POST", params);
}

export async function _SvFinanzasActualizarCargoDescuento(dato: TFinanzaCargo) {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "finanzas/ActualizarCargoDescuento";
    const params = <Partial<TFinanzaCargo> & IExtraData>{
        IdUsuario: DataUtil._Usuario.IdUsuario,
        IdCargo: dato.ID,
        Nombre: dato.Nombre,
        TipoValor: dato.TipoValor,
        Valor: dato.Valor
    }
    return DataDRequest._Request5(url, "POST", params);
}

export async function _SvFinanzasEliminarCargo(ids: Array<number>) {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "finanzas/EliminarCargo";
    const params = {
        Cargos: ids,
        IdUsuario: DataUtil._Usuario.IdUsuario
    }
    return DataDRequest._Request5<number[]>(url, "POST", params);
}

// Claves Producto / Servicio SAT

/** Si la consulta falla retorna la config del Cargo */
export function _SvFacturaObtenerClaveProdServSATByCargo(idEscuela: number, idCargo: number): Promise<DataDRequest.IRequestResponseA<ICatalogoSATClaveProductServ[]>> {
    const cargo = _DICC_FINANZAS_CARGOS.get(idCargo)
    let catalogoItemAux: ICatalogoSATClaveProductServ
    if (cargo?.ClaveProdServSAT)
        catalogoItemAux = { key: cargo.ClaveProdServSAT, name: cargo.NombreProdServSAT, complement: "" }
    return _SvFacturaObtenerClaveProdServSATBase(idEscuela, catalogoItemAux)
}

export function _SvFacturaObtenerClaveProdServSATBase(idEscuela: number, catalogoItemDefault: ICatalogoSATClaveProductServ): Promise<DataDRequest.IRequestResponseA<ICatalogoSATClaveProductServ[]>> {
    const catchList: ICatalogoSATClaveProductServ[] = []
    if (catalogoItemDefault)
        catchList.push(catalogoItemDefault)
    return new Promise(resolve => {
        if (!idEscuela) {
            resolve({ Resultado: 0, Datos: catchList })
            return
        }
        _SvFacturaObtenerCatalogoSATClaveProductServ(idEscuela)
            .then(res => {
                if (res.Resultado > 0) {
                    if (catalogoItemDefault && !res.Datos?.find(d => d.key == catalogoItemDefault.key)) {
                        res.Datos.push(catalogoItemDefault)
                    }
                    resolve(res)
                } else
                    resolve({ ...res, Datos: catchList })
            })
            .catch(() => resolve({ Resultado: 0, Datos: catchList }))
    })
}

// Claves Unidad SAT

/** Si la consulta falla retorna la config del Cargo */
export function _SvFacturaObtenerClaveUnidadSATByCargo(idEscuela: number, idCargo: number): Promise<DataDRequest.IRequestResponseA<ICatalogoSATClaveUnidad[]>> {
    const cargo = _DICC_FINANZAS_CARGOS.get(idCargo)
    let catalogoItemAux: ICatalogoSATClaveUnidad
    if (cargo?.ClaveUnidadSAT)
        catalogoItemAux = { key: cargo.ClaveUnidadSAT, name: cargo.NombreUnidadSAT }
    return _SvFacturaObtenerClaveUnidadSATBase(idEscuela, catalogoItemAux)
}

export function _SvFacturaObtenerClaveUnidadSATBase(idEscuela: number, catalogoItemDefault: ICatalogoSATClaveUnidad): Promise<DataDRequest.IRequestResponseA<ICatalogoSATClaveUnidad[]>> {
    const catchList: ICatalogoSATClaveUnidad[] = []
    if (catalogoItemDefault)
        catchList.push(catalogoItemDefault)
    return new Promise(resolve => {
        if (!idEscuela) {
            resolve({ Resultado: 0, Datos: catchList })
            return
        }
        _SvFacturaObtenerCatalogoSATClaveUnidad(idEscuela)
            .then(res => {
                if (res.Resultado > 0) {
                    if (catalogoItemDefault && !res.Datos?.find(d => d.key == catalogoItemDefault.key)) {
                        res.Datos.push(catalogoItemDefault)
                    }
                    resolve(res)
                } else
                    resolve({ ...res, Datos: catchList })
            })
            .catch(() => resolve({ Resultado: 0, Datos: catchList }))
    })
}

export function _SvFinanzasUtilEvaluarTipoInteres(cargo: TFinanzaCargo): Entidad.CFinanzaCargoTipoInteres {
    const defaultResult = Entidad.CFinanzaCargoTipoInteres.MontoUnico
    switch (cargo.TipoRecargo) {
        case Entidad.CFinanzaCargoTipoValor.Monto:
            return (cargo.IntervaloBloque == Entidad.CFinanzasCargoRecurrenciaRecargo.Diaria)
                ? Entidad.CFinanzaCargoTipoInteres.Simple
                : defaultResult
            break
        case Entidad.CFinanzaCargoTipoValor.Porcentaje:
            return cargo.TipoInteres || defaultResult
            break
    }
    return defaultResult
}

export function _SvFinanzasUtilEvaluarIntervaloBloque(cargo: TFinanzaCargo) {
    const defaultResult = Entidad.CFinanzasCargoRecurrenciaRecargo.Diaria
    return cargo.IntervaloBloque < 0
        ? defaultResult
        : cargo.IntervaloBloque || defaultResult
}

export function _SvFinanzasUtilEvaluarTipoTasa(cargo: TFinanzaCargo): Entidad.CFinanzasCargoTipoTasa {
    if (cargo.IntervaloBloque == Entidad.CFinanzasCargoRecurrenciaRecargo.Mensual) {
        return Entidad.CFinanzasCargoTipoTasa.Mensual
    }
    return Math.abs(cargo.TipoTasa) || Entidad.CFinanzasCargoTipoTasa.NoAplica
}
